import { render, staticRenderFns } from "./SurveyStep.vue?vue&type=template&id=4a6a5a8a&scoped=true&"
import script from "./SurveyStep.vue?vue&type=script&lang=js&"
export * from "./SurveyStep.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStep.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SurveyStep.vue?vue&type=style&index=1&id=4a6a5a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6a5a8a",
  null
  
)

export default component.exports